import { Component, Input, OnInit } from "@angular/core";
import textConfiguration from "../../../../assets/static-text-configuration.json";
import { MessageService } from "../../services/message.service";

@Component({
  selector: "app-access-denied",
  templateUrl: "./access-denied.component.html",
  styleUrls: ["./access-denied.component.scss"],
})
export class AccessDeniedComponent implements OnInit {
  authText: any = (textConfiguration as any).auth;

  constructor(private readonly messageService: MessageService) {}

  ngOnInit(): void {
    this.messageService.setGnews({ pagename: "Permission Denied Insights" });
  }
}
